// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OIlf","option":"styles_option__uzPgc","selected":"styles_selected__aFALZ"};